// extracted by mini-css-extract-plugin
export default {"edit-button__container":"EditButton_edit-button__container__NlDHp"};